import _ from "lodash";
import { useEffect } from "react";

export default function useIconPickerAccessibility({
  iconRefs,
  indexToIconNameMapRef,
  selectedIconName,
  uploadButtonRef,
}) {
  useEffect(() => {
    if (_.isUndefined(selectedIconName)) {
      if (uploadButtonRef.current) {
        uploadButtonRef.current.focus();
      }
    }
    if (indexToIconNameMapRef.current && iconRefs.current) {
      _.forEach(iconRefs.current, (ref, index) => {
        if (_.isEqual(indexToIconNameMapRef.current[index], selectedIconName)) {
          ref.focus();
        }
      });
    }
  }, []);

  const focusIcon = ({ destinationIndex, totalIcons }) => {
    if (destinationIndex < 0) {
      iconRefs.current[totalIcons - 1].focus();
    } else if (destinationIndex >= totalIcons) {
      iconRefs.current[0].focus();
    } else {
      iconRefs.current[destinationIndex].focus();
    }
  };

  const handleKeyDown = ({
    e,
    index,
    iconList,
    isUploadButtonEvent = false,
    toggleIconPicker,
  }) => {
    const totalIcons = _.size(iconList);
    switch (e.code) {
      case "Escape": {
        e.stopPropagation();
        toggleIconPicker();
        break;
      }
      case "Tab": {
        if (e.shiftKey) {
          if (isUploadButtonEvent) {
            toggleIconPicker();
          } else {
            uploadButtonRef.current.focus();
          }
        } else if (!isUploadButtonEvent) {
          toggleIconPicker();
        }
        break;
      }
    }

    if (isUploadButtonEvent) {
      return;
    }

    switch (e.code) {
      case "ArrowRight": {
        const destinationIndex = index + 1;
        focusIcon({ destinationIndex, totalIcons });
        break;
      }
      case "ArrowLeft": {
        const destinationIndex = index - 1;
        focusIcon({ destinationIndex, totalIcons });
        break;
      }
      case "ArrowDown": {
        const destinationIndex = index + 5;
        focusIcon({ destinationIndex, totalIcons });
        break;
      }
      case "ArrowUp": {
        const destinationIndex = index - 5;
        focusIcon({ destinationIndex, totalIcons });
        break;
      }
      default:
        break;
    }
  };
  return {
    handleKeyDown,
  };
}
